/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BodyCreateProjectApiProjectsPostAccessLevel = typeof BodyCreateProjectApiProjectsPostAccessLevel[keyof typeof BodyCreateProjectApiProjectsPostAccessLevel];


export const BodyCreateProjectApiProjectsPostAccessLevel = {
  private: 'private',
  shared: 'shared',
} as const;
